<script setup lang="ts">
  import { useRoute, useRouter } from 'vue-router'
  import { useAuthLogout } from '@/models/auth'
  import ModalSelectTenant from './tenant/modal-select-tenant.vue'

  const route = useRoute()
  const router = useRouter()

  const { submitting, logout } = useAuthLogout()
</script>

<template>
  <div class="fixed inset-x-0 top-0 z-20">
    <div class="max-w-2xl flex items-center justify-between rounded-b-md bg-primary py-4 container">
      <div class="flex items-center space-x-3">
        <app-button
          v-if="['shop order create', 'shop order detail'].includes(String(route.name))"
          class="flex-center text-white"
          @click="router.go(-1)">
          <fa-icon icon="i-far-chevron-left" />
        </app-button>
        <modal-select-tenant />
      </div>
      <div class="flex-center space-x-4">
        <!-- <template v-if="['shop order create', 'shop order detail'].includes(String(route.name))"> -->
        <app-button
          class="flex-center text-white"
          :to="{name: 'home'}">
          <fa-icon icon="i-far-house" />
        </app-button>
        <app-button
          class="flex-center text-white"
          :to="{name: 'product list'}">
          <fa-icon icon="i-far-box" />
        </app-button>
        <app-button
          class="flex-center text-white"
          :to="{name: 'shop order list'}">
          <fa-icon icon="i-far-receipt" />
        </app-button>
        <!-- </template> -->
        <app-button
          class="flex-center text-white"
          :loading="submitting"
          @click="logout">
          <fa-icon icon="i-far-right-to-bracket" />
        </app-button>
      </div>
    </div>
  </div>
</template>
